export const KenyahMenCostList = [ 
  { 
      name: "Bersunung", 
      img_src: " https://66.media.tumblr.com/d4464e21587e8067eac814608b28c6b0/8111c81f72459d11-1e/s540x810/233d36d18f9d0ff7634fb6933cfaa08f714ba4a0.png",
      description: "Bersunung is a top worn by the Kenyah men. Back in the days, this tops was worn by the men to war against their enemy. Hence, the material it came from: Skin of a deer or bear.",
      alt: "bersunung" 
  },

  {
      name: "Gelam bete", 
      img_src: " ",
      description: "Gelam Bete is a bangle worn on thigh by Kenyah men. ", 
      alt: "gelam-bete"
  }, 

  {
      name: "Tapung Puk / Terega",
      img_src: "https://66.media.tumblr.com/1c0646628adf0297625a7ab9fa2190e6/8111c81f72459d11-d0/s540x810/71c5b895448bcf358269f0f3ce3abae84085630e.png ",
      description: " Tapung Puk or Terega is a headgear adorn with the feathers of Kenyalang. It is decorated with colourful beads.",
      alt: "tapung-puk-terega"
  }, 

  {
      name: " Abet",
      img_src: "https://66.media.tumblr.com/69df8f193d52f6cdedffaefa5912dba4/8111c81f72459d11-7c/s540x810/db07954d79f7fa9767d4a69f86b718dbfd59f28f.png ",
      description: " Abet (cawat) is a piece of cloth to cover the men's lower body. The back of the Abet is called Tabit. The function of Tabit is to cover the back of the lower body portion as the man sits.",
      alt: "abet"
  }, 

]; 

export const KenyahWomenCostList = [
  {
      name: "Pakaian Perempuan Kenyah",
      img_src: " https://66.media.tumblr.com/15d03bccb63f8a3655f5553005a09c5b/51c22db41db6ee9a-c2/s540x810/3422a1c8a458be7ba77094b10c3fb9b2a9e316de.png",
      description: "The costume for Orang Ulu are decorated with colourful beads and its pattern is based on a dragon motifs. The costumes name as sapai and they will wear it with sarong called ta'a. Kenyah and Kayan have same patterns but have different motifs. The costume will be wear during traditional ceremony or festival. The colour of Kenyah costumes is not officially red colour because sometime it could be black in colour.",
      alt: "pakaian-perempuan-kenyah"
  },

  {
      name: "Tapung",
      img_src: " https://66.media.tumblr.com/360e437a6cb98c52a5f5768f0ef06eb5/29195d19bc46ee31-08/s540x810/bde33ea1cad3a65569861ea4223798531ec69e46.png",
      description: "Tapung is a hat with the bird feathers on the top of it. The hat is made of colourful beads. Tapung is used when women wearing the costume of Kenyah community. It will feel not complete if they wear the costume of Kenyah without using the Tapung.",
      alt: "tapung"
  }, 

  {
      name:" Sapai ",
      img_src: " ",
      description: "Sapai is a shirt worn by Kenyah women. It comes in a variety of design and motifs, and had different types of categories.",
      alt: "sapai"
  }, 

  {
      name: "Kirep",
      img_src: " https://66.media.tumblr.com/1ac2533d7777dafc66572802c21d3582/c72b337669f47609-2e/s540x810/ef89c8ba88875250ff10c2fb0f8aa6305305e60c.png",
      description: "Kirep is used for dancing. Back in the days, the feathers used to be of the hornbills, but because the hornbills has been categorised as an endangered species, the material to make the feathers has been replaced to something synthetic.",
      alt: "kirep"
  },

  { 
      name: "Uleng",
      img_src: " https://66.media.tumblr.com/b8dc3edef55a43307d1291b282841624/29195d19bc46ee31-9c/s540x810/f5699922c5eaed89061e88252a4bbc71e6816a37.png",
      description: " Uleng is a necklace made of beads. The Uleng beads comes in various patterns and intricate designs. This accessory is not limited to women, Kenyah men also wear it.",
      alt: "uleng"
  }, 

  { 
      name: "Benteng", 
      img_src: " https://66.media.tumblr.com/11cfd354991aac8712ae66932cc238d7/34aafbabbdb99523-e7/s540x810/75645a4a388e635daecf7282deebff1058617293.png",
      description: "The Benteng is a small belt worn with the traditional dress. It is made of colourful beads and stones. ", 
      alt: "beteng"
  }, 

  {
      name: "Belaung",
      img_src: " https://66.media.tumblr.com/ab8b53d6f2626923f9cf78d765cb80af/51c22db41db6ee9a-5e/s540x810/282684426ee143138d1d8373bd6d9f7d628427b2.png",
      description: "Belaung is an earing. It symbolizes for women's beauty. Belaung is heavy. It worn for a long time to make earlobe became  longer.  ",
      alt: "belaung"
  }, 

  {
      name: "Ino' Bengen",
      img_src: " https://66.media.tumblr.com/ba6dfbaf5dc9df5c68cab057d4bafab0/c72b337669f47609-f7/s540x810/2b27e8536bfeb77a7e2749a71c53ccdbc11b29a0.png",
      description: " Ino' Bangen is a type of necklace also known as a choker which is also a part of the traditional costume. It is made of colourful beads. ",
      alt: "ino-bengen"
  }, 

  {
      name: "Belanyat Ino",
      img_src: " https://66.media.tumblr.com/01a8a513651c719065a62b97cf682394/11f26048de86978e-b6/s540x810/2a2cb329c4509e2a295664b344ad15baf5b8b845.png",
      description: "Belanyat Ino is the name of a small basket that is a part of the traditional Kenyak costume. The function of Belanyat Ino is to put the harvested produce in. ",
      alt: "belanyat-ino"
  }, 

  {
      name: "Gelam", 
      img_src: " https://66.media.tumblr.com/cbbe1609a3162b6947c16c7dcfc443cb/34aafbabbdb99523-94/s540x810/82e7cc50a7de9010b910e7ff5b95a6815766308e.png",
      description: "Gelam is a bangle that clasps the arm. It is made of timber. There are different ways of calling the Gelam: Gelam lengen or Leku' and Geleng ino sip or Sileng.",
      alt: "gelam"
  }, 

  {
      name: "Sebakui Ino / Tebilang", 
      img_src: "https://64.media.tumblr.com/b1f804e9da2eb8f649213641e20ee8fc/b1053244b2622a5a-a0/s540x810/6075e8586fabd7b0e6035fd646e4d0bcc1c14ca5.png ",
      description: "Sebakui Ino or Tebilang is a shawl drapped over the shoulder of the Kenyah women's traditional costume. It is made out of colourful beadwork. ",
      alt: "sebakui-ino-tebilang"
  },

  {
      name: "Sabuk / Benteng",
      img_src: "https://66.media.tumblr.com/ed41efa1e1047ce474a2d3ab916da5f4/b1053244b2622a5a-00/s540x810/0c480cfea2388a1f6caec449aeb45dcc5fe3849f.png",
      description: "Sabuk is an accessory wrapped around waist. It is made out of colourful beads and stones. ",
      alt: "sabuk"
  }, 

];

export const KayanMenCostList = [
  {
      name:" Pakaian Lelaki Kayan", 
      img_src: " https://66.media.tumblr.com/4edfb2c66a48d33cf5bef7e4d7246ade/51c22db41db6ee9a-17/s540x810/5e9a25ab66dc20a94cd0136f4071ecdfc0add502.png", 
      description: " The traditional costume of Kayan men consists of a top made out of animal skin, mainly goat's skin. The traditional costume also consists of a headwear made out of rattan and embellished with colourful beads and Kenyalang feathers.",
      alt: "pakaian-lelaki-kayan"
  }, 

  {
      name: "Bluko", 
      img_src: "https://64.media.tumblr.com/0b0cabecd5bf2038f5ec920ef1037c46/4b8589e7b1c49d40-73/s400x600/e900a6632d26ef463cb04b5b17329a692138dd8a.jpg ",
      description: "Bluko is a headwear adorned with goat's fur and sometimes with tiger's fangs. Back in the days, the Bluko is believed to be able to protect its wearer due to the stength and agility of the material it came from.   ",
      alt: "bluko"
  },

  {
      name: "Leko Lengen",
      img_src: "https://64.media.tumblr.com/a71aa8363005f692ca1269e02013c318/4b8589e7b1c49d40-74/s540x810/a60c96d155f4c5e7124b5283485f9f5dc36bfb2a.jpg ",
      description: "Leko Lengen is a rattan bangle worn on the arm. Back in the days, Kayan men wore the leko to avoid getting hand cramps during war. ",
      alt: " leko-lengen"
  },
];

export const KayanWomenCostList = [
  {
      name: "Pakaian Perempuan Kayan", 
      img_src: " https://66.media.tumblr.com/1d2384517e8d41646720642aa609d488/51c22db41db6ee9a-9c/s540x810/06bcdbc7851bceea3f6a4b062d4ac15920a9021b.png",
      description: "The traditional costumes for Kayan women is identical to the Kenyah women's traditional costume. It was due to the history of the two ethnics. ",
      alt: "pakaian-perempuan-kenyah" 
  }, 

  {
      name: "Taping Se'",
      img_src: "https://66.media.tumblr.com/55a4df67de785ef2f6e9db25a2949bda/11f26048de86978e-67/s540x810/cc77b4ce5f9bacf7a48e3aaa17c0f889ae911b94.png ",
      description: "Tapung Se is a Kayan women's traditional headgear. It is embellished with colourful beadwork and goats' fur.",
      alt: "taping-se"
  }, 

  {
      name: "Sa'on Bead", 
      img_src: " https://66.media.tumblr.com/194994aca4136b1350a86f78eb503e55/b1053244b2622a5a-1e/s540x810/11dca54fd74657510dbb6c714c59bf9e0cdffeb3.png",
      description: "The Sa'on Bead is the Kayan traditional hat with designed with colourful beadwork.", 
      alt: "saon-bead"
  }, 

  {
      name: "Ta'a", 
      img_src: " https://66.media.tumblr.com/2036017510b21e0cec397fe47774fb80/29195d19bc46ee31-59/s540x810/e8fdca4b4294ecfef8962595e265e78b1963a6c6.png", 
      description: "Ta'a is a skirt paired with a Sapai. It comes in various types: Ta'a Aban, Ta'a Belep, and Ta'a Ino. Usually, the Ta'a Balep comes in a single colour and design motifs. However, it is still decorated with colourful beads. ", 
      alt: "Ta'a"
  }, 

  { 
      name: "Gelam Lengen", 
      img_src: " https://66.media.tumblr.com/6d0d2fd2950a27a0baa0ef6a75bd42ee/34aafbabbdb99523-67/s540x810/f811e10f4f45d4a2895b552cae6f400510a5e35f.png",
      description: "Gelam is a bangle that clasps the arm. It is made of timber. There are different ways of calling the Gelam: Gelam lengen or Leku' and Geleng ino sip or Sileng.",
      alt: "gelam-lengen"
      
  }, 

  {
      name: "Benteng & Tebing",
      img_src: "https://66.media.tumblr.com/49bb22c47d3fb65e42f8816aee647c84/34aafbabbdb99523-04/s540x810/751ce00a0ec16a39d0e833b6f357dd5de5e559b4.png ",
      description: "Benteng is an accessory wrapped around the Kayan women's waist. The Benteng is embelished with Tebing dangling aruond it. Tebing are made out of animals' fangs. ",
      alt: "benteng-tebing"
  }, 

  {
      name: "Ino Bengen",
      img_src: "https://66.media.tumblr.com/d5792ed95d5e618027a4823a28f8f1df/34aafbabbdb99523-d6/s540x810/a539dbfe7e40bef6f4d5075242d31298b5471a5b.png ",
      description: " Ino' Bangen is a type of necklace also known as a choker which is also a part of the traditional costume. It is made of colourful beads.  ",
      alt: "ino-bengen"
  },

  {
      name: "Sabo/Uleng",
      img_src: "https://66.media.tumblr.com/2161513af170492d91a91b617b736d40/b1053244b2622a5a-fb/s540x810/2a723a7167e81495cd74ad68a0ac5cef74f2ed1d.png ",
      description: "Sabo is a colourful, beaded necklace. It is an important piece of accessory to the Kayan traditional ensamble. ",
      alt: "sabo"
  },
];

export const PenanMenCostList = [
  {
      name: "Pakaian Lelaki Penan", 
      img_src: "https://66.media.tumblr.com/b23f8b7bd7d831bbaf1814464c5c847a/51c22db41db6ee9a-e4/s540x810/26131ebf12413c7887a617b2cccb0691b508fbf1.png ",
      description: "The Penan men traditional costume do not have much components to it. This is due to the fact that the costume only consists of the 'cawat' and clothing made out of animal skin. Another component of the Penan traditional costume is its headgear made out of rattan and Kenyalang feathers. ",
      alt: "pakaian-lelaki-penan"
  },
];

export const PenanWomenCostList = [
  {
      name: "Pakaian Perempuan Penan",
      img_src: "https://66.media.tumblr.com/b0baa3486bc20df2939157cbc7c19772/11f26048de86978e-72/s540x810/0949d2a9c3ff5eaa657327cd0e5f5645a016f56f.png ",
      description: "The Penan women's traditional costume is different compared to other ethnic's traditonal ensamble. Despite still having the Tapung as part of the costume . The Penan women's costume is fairly simple and unique. It doesn't have elaborate accessories. ",
      alt: "pakaian-perempuan-penan"
  },

  { 
      name :" Tapung", 
      img_src: "https://64.media.tumblr.com/48255344749533cdcec2e16ba5bfda16/4b8589e7b1c49d40-08/s540x810/d4bfe681fb94cf338bbca8c97b26a637f6323a6c.jpg ",
      description: " The Penan women's traditional headgear comes in a similar design with the Kayan and Kenyah's headgear. Tapun is made out of goat's hair and are embelished with colourful beads.",
      alt: "tapung"
  },

  {
      name: " Kain Penan",
      img_src: " https://66.media.tumblr.com/134d68cebbea0c2f6ad85a179ca2c696/c72b337669f47609-a9/s540x810/2d64a0d8b5c63eb61536284896a3d6af2b2435ee.png",
      description: " Kain Penan is comes in a different design compared to the other Orang Ulu's traditional skirt. The design is not elaborate and it is almost snake's skin-like. ",
      alt:"kain-penan"
  },

];

export const KelabitMenCostList = [
  { 
      name: "Pakaian Lelaki Kelabit (during festivities)",
      img_src: " https://66.media.tumblr.com/519cf9a4dcce6a4ce49b1c3cda63ad29/f4ef3ad1d14ccd9f-a9/s540x810/857aab598003a233557d428d855f46c27aebc4ce.png",
      description: "The Kelabit men's traditional costume comes in 2 types: The ones they wore during festivities and their casual costumes. The traditional ensamble they wore during festivities consists of colourful beaded jacket or a fur vest made out of animal's skin . The vests are being put on along with a 'cawat', a piece of cloth to cover the men's lower body. The headgear worn during special occasions are also different from their casual traditional headgear, it is decorated with Kenyalang feathers and full of colourful beads.",
      alt: "pakaian-lelaki-kelabit-1"
  },

  {
      name: "Pakaian Lelaki Kelabit (casual)",
      img_src: " https://66.media.tumblr.com/76a51e1e0ed22e6407708ea4bf7e43ef/b1053244b2622a5a-ce/s540x810/f4f19ce6648feeecb60b5d923cbf9b50bdcb3fec.png",
      description: "The casual form of Kelabit men's tradtional costume consists of a vest made out of tree bark. It is almost similar to the Penan's traditioal vest. The Kelabit's hat is also almost similar to the Penans. It is made out of rattan and decorated with Kenyalan feathers.",
      alt: "pakaian-lelaki-kelabit-2"
  }, 

  {
      name: " Padaleh",
      img_src: "https://66.media.tumblr.com/bfd8a96d1c2aaa17e667a199bf8c2e74/b1053244b2622a5a-fa/s540x810/701de851284331fe36f7204d3d5ca8dd2c547640.png ",
      description:"Padaleh is necklace made out of colourful beads and stones.",
      altv: "padaleh"
  },
]; 

export const KelabitWomenCostList = [
  {
      name: "Pakaian Perempuan Kelabit",
      img_src: "https://66.media.tumblr.com/88723d1d164a763cfd785f4d5271efe7/51c22db41db6ee9a-cf/s540x810/a110eb9df6c0ad2fcb11fac019979dd29e006c80.png ",
      description: "The Kelabit women's traditional costume comes with a long skirt that covers the knee. The whole ensamble also consists the use of beaded necklace and beaded headwear.",
      alt: "pakaian-perempuan-kelabit"
  },

  {
      name: "Peta / Baorawir",
      img_src: "https://66.media.tumblr.com/9303c393c7b4fc18176525923cd31b63/b1053244b2622a5a-d8/s540x810/27d869cf461ccc687d33809df4db2ed81c7df93b.png ",
      description: "Peta is the Kelabit women's traditional headgear. The Peta is made out of colourful beads.", 
      alt: "peta"
  }, 

  {
      name: "Leku",
      img_src: "https://66.media.tumblr.com/df3ed906975388a4b40af3d177c576c2/c72b337669f47609-44/s540x810/edbe1cfe28b6535137c7ee9829b911901a6d16d4.png ",
      description: "Leku is a bangle. ", 
      alt: "leku"
  }, 

  {
      name: "Bane Tegu",
      img_src: "https://66.media.tumblr.com/a08f6a9b8838e08e87e51c260ba108b8/11f26048de86978e-82/s540x810/f0658542bf66034523fb2a56991093636257fcc1.png ",
      description: "Bane Tegu is a chocker-like beaded necklace. It is one of the Kelabit traditonal accessories and is part of the traditional costume.",
      alt: "bane-tegu"
  },

  {
      name: "Belaung",
      img_src: "https://66.media.tumblr.com/b12868217dcbe949368adac9ee9e2d8c/34aafbabbdb99523-b1/s540x810/a79b6ca7ea32a667dac176ff39de751a35b636aa.png ",
      description: "Belaung is a heavy, brass earings. Back in the days, the beaded belaung were put on Kelabit women ever since they were babies though they were as heavy. The 'belaung' symbolises the women's social status and beauty. ",
      alt: "belaung"
  }, 

  {
      name: " Bane Kabo",
      img_src: "https://66.media.tumblr.com/d01f9e3682c50e3e600223ab09637120/11f26048de86978e-4c/s540x810/9fbcd91a55d75d3bc2d70fdb5fc69af1c912da65.png ",
      description: "Bane Kabo is a beaded necklace worn across the different Orang Ulu sub-ethnics. The huge red lump of ball in the middle of the necklace called 'Kabuq'.",
      alt :"bane-kabo"
  }, 

  { 
      name: "Uyut Ba'o", 
      img_src: "https://66.media.tumblr.com/e60186819ab74402c04fcf9cb516ac37/29195d19bc46ee31-b7/s540x810/9d3a436a4afdf67b73565511f4f3e096eddf4266.png ",
      description: " Uyut Ba'o is a small, beaded basket. It is also part of the Kelabit traditional costume as it is usually carried over the shoulder. ", 
      alt: "uyut-bao"
  }, 

  {
      name: "Bao Kura",
      img_src: "https://66.media.tumblr.com/dee8c7ba851b9b806841121e6fea0b02/11f26048de86978e-fe/s540x810/701c2a6bf115865ae733964b19538f2189e386c5.png ",
      description: "Bao Kura is another type of necklace and is a traditonal accessory. It is made out colourful stones ",
      alt:"bao-kura" 
  }, 

  {
      name: "Bata Agan / Beret",
      img_src: "https://66.media.tumblr.com/3061a9bfa6eccfe7785b5ee7915bc48b/11f26048de86978e-d7/s540x810/be5e3da9909da7d90e901e50c9183e1bc05bcd29.png ",
      description: "Bata Agen or Beret is a beaded, belt-like accessory that is worn around the waist.",
      alt: "bata-agan"
  },

  {
      name: "Selendang Manik",
      img_src: " https://66.media.tumblr.com/b1f804e9da2eb8f649213641e20ee8fc/b1053244b2622a5a-a0/s540x810/6075e8586fabd7b0e6035fd646e4d0bcc1c14ca5.png",
      description: "Selendang Manik is a beaded sash worn together with the traditional costume. Because of its elaborate design, the sash requires a long time to make it.",
      alt: "selendang-manik"
  },

  {
      name: "Sa'ong",
      img_src: "https://66.media.tumblr.com/c6aa11189c5c9bb243e5b3d074b65f8f/b1053244b2622a5a-02/s540x810/a7098385f6df18ed3c766f7eabca18e84b710f70.png ",
      description: "Sa'ong is the name of a hat. The hat has fine textile patchwork throughout on a palm leaf base. This type of hat was used usually by the women while working in the fields or to shade the baby. ", 
      alt: "saong"
  }, 

]; 

export const BisayaMenCostList = [
  {
      name: "Pakain Lelaki Kaum Bisaya",
      img_src: "https://66.media.tumblr.com/0eee9d217c5f86efe3bd493a5e92635a/51c22db41db6ee9a-a0/s540x810/36c965e88682fa1b0cd75d935e9d1ca528c5d86c.png ",
      description: "The Bisaya men traditional costume far simple compared to other Orang Ulu traditional attire. It reflects on the Bisaya's socio-economic as farmers. Th Bisaya costume is made out of black velvet with long sleeves. The top are embelished with gold-coloured thread on its seams.",
      alt: "pakaian-lelaki-kaum-bisaya"
  }
];

export const BisayaWomenCostList = [
  { 
      name: "Baju Kebamban",
      img_src: "https://66.media.tumblr.com/f5fcfe6a4c7099fa4434e83d1ca9d92f/11f26048de86978e-a6/s540x810/75c399c14140371df0c646a26586dd1b9ed91c51.png ",
      description: "Baju Kebamban / Baju Masuk is the name of a traditional shirt worn by Bisaya women.", 
      alt: "baju-kebamban"
  }, 

  {
      name: " Kain Tanjung / Tanjung Serat",
      img_src: " https://66.media.tumblr.com/c9c2f47e1b02ae0734f2902556508a3a/c72b337669f47609-bd/s540x810/91c3c7a41b883c000b3dae0d627a18112af9fe0e.png",
      description: " Kain Tanjung or Tanjung serat is the skirt worn with the Baju Kebamban.",
      alt: "kain-tanjung"
  }, 

  {
      name: "Susuk Sanggul",
      img_src: "https://66.media.tumblr.com/01521197b81c25402591fe4c6fd457a5/29195d19bc46ee31-ac/s540x810/560d2297f937276ae47fd9602f9e478b6c6d6985.png ", 
      description: "Susuk Sanggul is a Bisaya traditional hair accessory. It is made out of lead. ",
      alt: " susuk-sanggul"
  }, 

  {
      name: "Manik Beliling Sanggul", 
      img_src: "https://66.media.tumblr.com/3ad6a03182b5836a3780b42c6b42259c/b1053244b2622a5a-7b/s540x810/ea2633a8d86422104cdf6b17a590df0c6ee54903.png ",
      description: "Manik Beliling Sanggul is a colourful beaded hair tie. A woman's hair would have to be tied into a bun.",
      alt: "manik-beliling-sanggul"
  },

  {
      name: "Padapun",
      img_src:"https://66.media.tumblr.com/3ec0f28fd9de54176de661456d254734/b1053244b2622a5a-fd/s540x810/91ac75a6ec09de8ae7808ff8f047b99e2c8e766f.png ",
      description: "Padapun is a type of necklace that is designed in tiers. It is often paired when wearing the complete Bisaya costume. It is made out of light-weight lead. ",
      alt: "padapun"
  },

  {
      name: "Kupu-kupu",
      img_src: " https://66.media.tumblr.com/73cf507e92b26651038721e2a6e76428/c72b337669f47609-9a/s250x400/d32bd1179a945485cbfb3ddfebb18ea5d08ae0a0.png",
      description:"Kupu-kupu is an brooch-like accessory. It is clipped onto the Baju Kebamban. It is made out of light-weight lead.",
      alt: "kupu-kupu"
  },

  {
      name: "Golong Alu-Alu", 
      img_src: " https://66.media.tumblr.com/f138dce21cc5847cf58af457d2155dff/34aafbabbdb99523-dc/s540x810/0f3c0a47d57555940ba2acc400c6f61dab85be91.png",
      description: "Golong Alu-Alu is a bangle. The Bisaya traditional jewellery comes in various types or design. Golong Alu-Alu is one of the accessories that completes the traditional costume ensamble. ",
      alt: "golong-alu-alu"
  },

  {
      name: "Golong Satak / Sengkadan ",
      img_src: "https://66.media.tumblr.com/9aa72153f4396b8f927b3cb107232620/34aafbabbdb99523-b2/s540x810/4caf5ec97063b6523e1196308f2026aeb4d3df63.png ",
      description: "Golong Satak or Sengkadan is one of the Bisaya women's jewellery. The design of this bangle is slightly different from Golong Alu-Alu due its size and design patterns.",
      alt: "golong-satak"
  },

];

export const LunBawangMenCostList = [
  {
      name: "Kuyu Tulun",
      img_src: "https://66.media.tumblr.com/1e6689a17b5bd9788db1d8730ca6a210/c72b337669f47609-37/s540x810/2fe3d4f8bfbabf48031baf0a86763541d91228ae.png",
      description: "Kuyu Talun is a Lun Bawang men's traditional costume made out of tree bark. It is designed as a vest.",
      alt: "kuyu-tulun"
  }, 

  {
      name: "Sigar",
      img_src: " ",
      description: "Sigar is a headscarf. Unlike other Orang Ulu sub-ethnics, Lun Bawang men does not have any elaborate headwear but instead, their costume consists of this simple, usually red, scarf.",
      alt:"sigar"
  }, 

  {
      name: " Abpar ",
      img_src: " ",
      description: "Abpar is a piece of cloth to cover the men's lower body or in other words, a loin cloth. It is similar to the Abet or Cawat only with different name. ",
      alt: "abpar"
  }
];

export const LunBawangWomenCostList = [
  {
      name: "Pata",
      img_src: "https://66.media.tumblr.com/2ebffde6e6d722b42147c31f25af61eb/11f26048de86978e-7b/s540x810/2d4afad1be33fc8149afc59d0a2912bdd7257f9f.png ",
      description: "Pata is a Lun Bawang women's headgear. It is made out for beads and is usually yellow, white, or red in colour. The non-elaborate design of the Pata makes it almost seem as if it is a beaded headscarf. ", 
      alt: "pata"
  },

  {
      name: "Beret",
      img_src: "https://66.media.tumblr.com/e1af97bc055ece95fdabf34e426d7ca9/34aafbabbdb99523-2f/s540x810/b277c1da46c9de18f64e7ff17b81a7379195298f.png ",
      description: "Beret is an accessory that serves as a belt to the traditional Lun Bawang costume. Most of the Orang Ulu ethnics have this kind of accessory only that it has different names to it. Plus, the design and motifs are also different making it slightly easier to others to differentiate which of the ethnics it belongs to. However, one aspect remains similar: It is made out of beads", 
      alt: "beret"
  }, 

  {
      name: "Bane ",
      img_src: "https://66.media.tumblr.com/8ae15f38636909f1cbc32a2744503700/11f26048de86978e-f0/s540x810/c310cc8c0fa8dfb758cef6a15d0c7a05211d011d.png ", 
      description: "Bane is beaded necklace with a huge red lump of ball in the middle of the necklace . This necklace can be seen across most of the Orang Ulu ethnics.",
      alt: "bane"
  }, 

  {
      name: "Gileng & Pakel", 
      img_src: "https://66.media.tumblr.com/3348c5f484e74304d49db829bb26b976/34aafbabbdb99523-38/s540x810/4a5700391b26bc5357afd9723519173de583727b.png ", 
      description: "Gileng and Pakel are traditional bracelets worn on the wrists and arms of Lun Bawang women. Back in the days, these bracelets were made out of rattan but now, most of them are made of lead or beads. ",
      alt: "gileng-pakel"
  }
]